module.exports = __webpack_public_path__ + "static/media/medium.a193b4cb.png";